export default __webpack_public_path__ + "static/media/aequalis15.0b2c4a1c.pdf";